// Libraries
import { MenuItemType } from 'antd/es/menu/hooks/useItems';

// Types
import { EquipmentUnitDataConeCrusher } from '../../../../../../types/crusher';
import { EdgeDeviceOperationalStatus } from '../../../../../../types/global';

export enum ComboUnitType {
  sensors = 'sensors',
  valveBank = 'valveBank',
}

export type ComboUnitItemTab = {
  key: ComboUnitType;
  label: string;
};

export interface ComboUnitProps {
  className?: string;
  onChangeView: (key: MenuItemType) => void;
  unitData: EquipmentUnitDataConeCrusher | null;
  edgeStatus: EdgeDeviceOperationalStatus | null;
  selectedView: ComboUnitType;
  testId?: string;
}
